import { type AppInfo } from '../../../types';
import { useEmbeddedCopy } from '../../../hooks/useEmbeddedCopy';
import EmbeddedStatusScreen from '../shared/StatusScreen';

/**
 * "Yivi didn't open?": it may not be installed on this phone. Back returns to
 * the screen it came from; installing is the one action that screen lacks.
 */
export default function EmbeddedNotOpenedScreen({
  app,
  onInstall,
  onBack,
}: {
  app?: AppInfo;
  onInstall: () => void;
  onBack: () => void;
}) {
  const { t } = useEmbeddedCopy();
  const appName = app?.name ?? '';
  return (
    <EmbeddedStatusScreen
      visual="help"
      title={t('embedded.notOpened.title', { app: appName })}
      sub={t('embedded.notOpened.sub', { app: appName })}
      primary={{
        label: t('embedded.notOpened.install', { app: appName }),
        onClick: onInstall,
      }}
      secondary={{ label: t('embedded.back'), onClick: onBack }}
    />
  );
}
